'use es6';

import moment from 'moment/moment'; // eslint-disable-next-line no-undef

hubspot.define('moment', [], function () {
  return moment;
});
export default moment;